import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { generateKey } from '@/utils';
import Placeholder from '../../../components/Placeholder';
import Image from '../../../components/ContentfulImage';
import TopicTout from './TopicTout/TopicTout';
import {
  ColumnOne,
  ColumnTwo,
  Section,
  FirstImageWrapper,
  FirstToutWrapper,
  SecondImageWrapper,
  SecontToutWrapper,
  ThirdImageWrapper,
  ThirdToutWrapper,
  Arrow,
  ArticleContentNameAndArrow,
  ArticleContents,
  ArticleContent,
  ArticleContentImage,
  ArticleContentNameWrapper,
  ArticleContentName,
  Linker,
} from './HomeTouts.style';

const options = { h: '100%', w: '100%', objectFit: 'cover', size: [585, 885, 595, 720, 720] };

const HomeTouts = ({ topics, article, locale }) => (
  <Section>
    <ColumnOne>
      <Link to={`/${locale}${topics[0].linkUrl}`} href={`/${locale}${topics[0].linkUrl}`}>
        <FirstImageWrapper>
          {topics[0].image ? (
            <Image src={topics[0].image} options={options} />
          ) : (
            <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />
          )}
        </FirstImageWrapper>
        <FirstToutWrapper>
          {topics[0].icon ? <TopicTout {...topics[0]} /> : <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />}
        </FirstToutWrapper>
      </Link>

      <Link to={`/${locale}${topics[2].linkUrl}`} href={`/${locale}${topics[2].linkUrl}`}>
        <SecondImageWrapper>
          {topics[2].image ? (
            <Image src={topics[2].image} options={options} />
          ) : (
            <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />
          )}
        </SecondImageWrapper>
        <SecontToutWrapper>
          {topics[2].icon ? <TopicTout {...topics[2]} /> : <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />}
        </SecontToutWrapper>
      </Link>
    </ColumnOne>

    {/* BEAUTY FOR YOU リンク */}
    <ColumnTwo>
      <Link to={`/${locale}${topics[1].linkUrl}`} href={`/${locale}${topics[1].linkUrl}`}>
        {/* イメージ画像表示部分 */}
        <ThirdImageWrapper>
          {topics[1].image ? (
            <Image src={topics[1].image} options={options} />
          ) : (
            <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />
          )}
        </ThirdImageWrapper>
        {/* リンク誘導テキスト 表示部分 */}
        <ThirdToutWrapper>
          {topics[1].icon ? <TopicTout {...topics[1]} /> : <Placeholder h="calc(100% - 5px)" w="calc(100% - 5px)" />}
        </ThirdToutWrapper>
      </Link>
      <ArticleContents className={!article ? 'placeholder' : null}>
        {!article ? (
          <Placeholder w="calc(100% - 5px)" h="calc(100% - 5px)" />
        ) : (
          <React.Fragment>
            {article.map(({ title, image, url, external, content, author }, index) => (
              <ArticleContent
                key={generateKey('article', index)}
                className={!(content && author) ? 'linkHolder' : 'linkNonHolder'}
              >
                {external && (
                  <Linker href={url} target="_blank">
                    <ArticleContentImage src={image.file.url} alt="" />
                    <ArticleContentNameWrapper className="linkHolder">
                      <ArticleContentNameAndArrow>
                        <ArticleContentName className="linkHolder">{title}</ArticleContentName>
                        <Arrow />
                      </ArticleContentNameAndArrow>
                    </ArticleContentNameWrapper>
                  </Linker>
                )}
                {!external && (
                  <React.Fragment>
                    {!!(image && _.get(image, 'file')) && (
                      <Link to={`/${locale}${url}`} href={`/${locale}${url}`}>
                        <ArticleContentImage src={image.file.url} alt="" />
                        <ArticleContentNameWrapper className="linkHolder">
                          <ArticleContentNameAndArrow>
                            <ArticleContentName className="linkHolder">{title}</ArticleContentName>
                            <Arrow />
                          </ArticleContentNameAndArrow>
                        </ArticleContentNameWrapper>
                      </Link>
                    )}
                    {!!(!image && content && author) && (
                      <React.Fragment>
                        <ArticleContentName className="linkNonHolderContent">{content}</ArticleContentName>
                        <ArticleContentName className="linkNonHolderAuthor">{author.name}</ArticleContentName>
                        <ArticleContentName className="linkNonHolderAuthor">{author.title}</ArticleContentName>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                )}
              </ArticleContent>
            ))}
          </React.Fragment>
        )}
      </ArticleContents>
    </ColumnTwo>
  </Section>
);

HomeTouts.defaultProps = {
  topics: [{}, {}, {}],
  article: null,
};

HomeTouts.propTypes = {
  locale: PropTypes.string.isRequired,
  topics: PropTypes.arrayOf(PropTypes.shape()),
  // BEAUTY CONSULTATION、COLOR MIRROR のリンク情報
  article: PropTypes.arrayOf(PropTypes.shape({})),
};

export default HomeTouts;



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomeTouts/HomeTouts.js